import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../environments/environment';
import * as _ from 'lodash';
import { EmojiServiceService } from '../services/emoji-service.service';
import { StorageService } from '../services/storage.service';
import { LocaleService } from '../services/locale.service';
import { GeoService } from '../services/geo.service';

@Component({
  selector: 'app-endGame',
  templateUrl: './endGame.component.html',
  styleUrls: ['./endGame.component.scss']
})
export class EndGameComponent implements OnInit {
  players = [];
  bgColor;
  loaders = {
    refresh: false
  }
  groupId;
  activeGame;
  pageConfig = {
    gameId: null,
    playerId: null,
    activeTab: 'leaderboard'
  };
  virtualModeActive = false;
  fakeUsers = [];
  locales = {
    hallOfFame: this.localeService.getTrans('Hall of fame'),
    congrats: this.localeService.getTrans('Congrats! The game has ended!'),
    byDistance: this.localeService.getTrans('By Distance'),
  }
  constructor( 
    private route: ActivatedRoute,
    private router: Router, 
    private http: HttpClient,
    public localeService: LocaleService,
    private geoService: GeoService,
    public emojiService: EmojiServiceService, private storageService: StorageService) {
      if (this.route.snapshot.paramMap.get('g') && this.route.snapshot.paramMap.get('p')) {
        this.storageService.removeStorage('fl_storage');
        this.pageConfig.gameId = this.route.snapshot.paramMap.get('g');
        this.pageConfig.playerId = this.route.snapshot.paramMap.get('p');
        this.groupId = this.route.snapshot.paramMap.get('groupId');
        this.getGame(this.route.snapshot.paramMap.get('g'), this.route.snapshot.paramMap.get('p'));
      } else{
        this.navigateBack();
      } 
  }
  refresh(){
    if(this.pageConfig.activeTab === 'leaderboard'){
      this.getGame(this.route.snapshot.paramMap.get('g'), this.route.snapshot.paramMap.get('p'));
    } else{
      this.getDistance(this.route.snapshot.paramMap.get('g'));
    }
  }

  navigateToCustomRedirectURL(){
    if(this.activeGame.tourId && this.activeGame.tourId.customRedirectURL){
      window.location.href = this.activeGame.tourId.customRedirectURL;
    }
  }

  navigateToRelive(){
    console.log(this.route.snapshot.paramMap.get("g"))
      window.location.href = environment.portalUrl + 'relive/' + this.route.snapshot.paramMap.get("g");
  }

  setTab(activeTab){
    this.pageConfig.activeTab = activeTab;
    if(this.pageConfig.activeTab === 'leaderboard'){
      this.getGame(this.route.snapshot.paramMap.get('g'), this.route.snapshot.paramMap.get('p'));
    } else{
      this.getDistance(this.route.snapshot.paramMap.get('g'));
    }
  }

   share(){
    if (navigator.share) {
      navigator.share({
        title: 'Flinkit! Outdoor! | Leaderboard',
        url: window.location.href
      }).then(() => {
        
      })
      .catch(console.error);
    } else {
      console.log('Share is not supported')
    }
  }

  getDistance(gameId){
    this.loaders.refresh = true;
    return this.http.post(environment.baseUrl + 'games/getDistanceByGame', {gameId, groupId: this.route.snapshot.paramMap.get('groupId')} ).subscribe((data: any) => {
      this.loaders.refresh = false;
      if(data.success){
        console.log(data)
         this.players = _.orderBy(data.data, ['distance'], ['desc']);
         
         // Add fake users if virtual mode is active
         if (this.virtualModeActive) {
           this.addFakeUsersToLeaderboard();
           // Reorder by distance for distance tab
           this.players = _.orderBy(this.players, ['distance'], ['desc']);
         }
         
         console.log(this.players)
      } else{
        this.navigateBack()
      }
    }); 
  }

  getGame(gameId, player){
    return this.http.post(environment.baseUrl + 'games/getGameRes', {groupId: this.groupId} ).subscribe((data: any) => {
     if(data.success){
      console.log(data)
        this.activeGame = data.game;
        this.activeGame.partner = data.partner;
        this.players = _.orderBy(data.players, ['points'], ['desc']);
        this.bgColor = this.activeGame.partner ? ((this.activeGame.tourId.isCustomBranding && this.activeGame.tourId.customBranding.color) ? this.activeGame.tourId.customBranding.color : (this.activeGame.partner.color ? this.activeGame.partner.color : null)) : null;

        // Check for virtual mode and add fake users
        this.checkVirtualMode();
        if (this.virtualModeActive) {
          this.addFakeUsersToLeaderboard();
        }

     } else{
       this.navigateBack()
     }
   }); 
 }
  
  checkVirtualMode() {
    const urlParams = new URLSearchParams(window.location.search);
    const virtualParam = urlParams.get('virtual');
    let showcase = urlParams.get('showcase');
    if (!showcase) {
      const fullUrl = window.location.href;
      const pathPart = fullUrl.split('?')[0];
      const matrixMatch = pathPart.match(/[;]showcase=([^;?]+)/);
      if (matrixMatch) {
        showcase = matrixMatch[1];
      }
    }
    this.virtualModeActive = showcase === 'true' && virtualParam !== null;
  }

  addFakeUsersToLeaderboard() {
    // Create fake users if they don't exist yet
    if (this.fakeUsers.length === 0) {
      const fakeNames = ['Alex', 'Sam', 'Jordan', 'Taylor', 'Casey', 'Morgan', 'Riley', 'Quinn'];
      const numFakeUsers = Math.floor(Math.random() * 4) + 5; // 5-8 fake users
      const maxAvatarCount = this.emojiService?.getEmojis?.().length || 19; // currently 0..18
      
      for (let i = 0; i < numFakeUsers; i++) {
        const randomName = fakeNames[Math.floor(Math.random() * fakeNames.length)] + Math.floor(Math.random() * 100);
        const randomAvatar = Math.floor(Math.random() * maxAvatarCount);
        const randomPoints = Math.floor(Math.random() * 500) + 50;
        
        this.fakeUsers.push({
          _id: 'fake_' + i,
          name: randomName,
          points: randomPoints,
          avatarIndex: randomAvatar,
          distance: Math.floor(Math.random() * 10) + 1, // For distance tab
          isFake: true
        });
      }
    }
    
    // Add fake users to players array
    const realPlayers = this.players.filter(p => !p.isFake);
    this.players = _.orderBy([...realPlayers, ...this.fakeUsers], ['points'], ['desc']);
  }


  navigateBack() {
    this.router.navigate(['/']);
  }

  ngOnInit() {
    this.storageService.removeStorage('fl-game-details');
    this.checkVirtualMode();
    setTimeout(()=>{
      this.geoService.dropConfetti();
    },1000)
  }

}
